import log from "logbeacon";
import { useEffect, useState } from "react";
import { radarCryptoDomain } from "../componentsv1";
import { ROUTER_PATH } from "@/src/config/router";
import { useRedirectChat, useShellRouter } from "@/src/hooks";
import { encodeString } from "@/src/utils/stringEncoder";

export const useGoToDetail = (type?: "crypto" | "stock") => {
  const router = useShellRouter();
  const { handleCheckChatVaild } = useRedirectChat();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 3000);
      return () => {
        setIsLoading(false);
        clearTimeout(timer);
      };
    }
  }, [isLoading]);

  const onCryptoDetail = (record: any, dex_id?: string) => {
    if (dex_id === radarCryptoDomain.dexTracker && record.id) {
      const path = `${ROUTER_PATH.POOL_TOKEN}/${record.id}`;
      router.push(path);
    } else if (record.id) {
      const path = `${ROUTER_PATH.CRYPTO_TOKEN}/${record.id}`;
      router.push(path);
    } else {
      const sign = `token_introduction${record.id ? `_${encodeString(`id#${record.id}`)}` : ""}`;
      handleCheckChatVaild({
        question: record.symbol || "",
        sign,
      });
    }
  };

  const onStockDetail = (record: any) => {
    router.push(`${ROUTER_PATH.STOCK_DETAIL}/${record.symbol}`);
  };

  const onDetail = (record: any, dex_id?: string) => {
    log.debug("[useGoToDetail] onRow", record, type);
    if (isLoading || !record) {
      return;
    }
    const curType = type ? type : record?.type;
    setIsLoading(true);
    if (curType === "crypto") {
      onCryptoDetail(record, dex_id);
    } else {
      onStockDetail(record);
    }
  };

  return {
    onDetail,
    isLoading,
  };
};
